import PropTypes from "prop-types"
import { useLocalization } from "gatsby-theme-i18n"
import React from "react"
import { Helmet } from "react-helmet"
import { useThemeUI } from "theme-ui"
import { useStaticQuery, graphql } from "gatsby"

function Head({ description, meta, title }) {
  const { locale, config } = useLocalization()
  const { theme } = useThemeUI()
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const currentLocale = config.filter(lang => lang.code === locale)

  const metaDescription = description || site.siteMetadata.description

  const metaTags = [
    {
      name: `description`,
      content: metaDescription,
    },
    {
      name: `og:title`,
      content: title,
    },
    {
      name: `og:description`,
      content: metaDescription,
    },
    {
      name: `og:type`,
      content: `website`,
    },
    {
      name: `twitter:card`,
      content: `summary`,
    },
    {
      name: `twitter:creator`,
      content: site.siteMetadata.author,
    },
    {
      name: `twitter:title`,
      content: title,
    },
    {
      name: `twitter:description`,
      content: metaDescription,
    },
  ].concat(meta)

  return (
    <Helmet
      htmlAttributes={{
        lang: currentLocale[0].hrefLang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
    >
      {metaTags.map(tag => (
        <meta key={tag.name} name={tag.name} content={tag.content} />
      ))}
      <meta name="theme-color" content={theme.colors.primary} />
    </Helmet>
  )
}

Head.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Head.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default Head
